// Unpublished Work © 2022-2025 Deere & Company.

import React from 'react';
import {
    ErrorPage
} from '@deere/cap-it-ui.component-library';
import {Button} from '@deere/fuel-react/Button';
import styles from './page-error.module.scss';
import {FormattedMessage} from 'react-intl';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

export const DefaultError = (props) => {
    const history = useHistory();

    const errorMessage = (
        <div>
            {props.message && <div className={styles.message}>{props.message}</div>}
            <span className={styles.couldNotLoad}>
                <FormattedMessage id='messages.CONTENT_COULD_NOT_BE_LOADED'/>
            </span>
            <FormattedMessage id='messages.TECHNICAL_SUPPORT'/>
        </div>
    );

    return (<ErrorPage message={errorMessage}>
        <div>
            <Button
                className={styles.goBack}
                label='labels.BACK'
                onClick={history.goBack}
                variant={'secondary'}
            >
                <FormattedMessage id={'labels.BACK'}/>
            </Button>

            <a
                href='https://johndeere.service-now.com/dp'
                rel='noopener noreferrer'
                target='_blank'
            >
                <Button variant={'primary'} >
                    <FormattedMessage id={'labels.CONTACT_TECHNICAL_SUPPORT'}/>
                </Button>
            </a>
        </div>
    </ErrorPage>);
};

DefaultError.propTypes = {
    message: PropTypes.string
};
